import { observable } from '@legendapp/state';

export const realtimeTrigger = observable({ counter: 0 }); 